export const MUTE_CHAT_PERIODS = [
  { name: 'weeks', label: 'Weeks' },
  { name: 'days', label: 'Days' },
  { name: 'hours', label: 'Hours' },
]
